import styling from '../core/styling.js';
import EngineDefinition from './foundation/engineDefinition.js';
import spinnerCctr from '../components/spinner.js';
import { mapContainerId } from '../complete/mainMap';

class PlaylistEngine extends EngineDefinition {

    /**
     * The map view/track currently played.
     */
    currentView;

    timerPaused = false;

    /**
     * Holds the timeout id for the track switch.
     */
    trackSwitchTimeoutId = null;

    /**
     * Holds the timeout id for the next data load
     */
    
    dataLoadingTimeoutId = null;

    engines = [];
    views;

    constructor(args, mapName) {
        super(args, mapName ?? "playlist");

        styling.setTheme(args.theme || styling.defaultTheme);

        this.spinner = args.spinner ?? spinnerCctr();
        const { identifier, defaultDurationSeconds, displayLogo, mapStyle } = args;
        this.views = args.views;
        let { state } = this;
        state.mapConfig = mapStyle || {};

        const { style } = state.mapConfig;
        if (!!style) {
            var now = new Date();
            var time = now.getTime();
            time += 3630 * 1000;
            now.setTime(time);
            document.cookie = `mapstyle=${style}; expires=${now.toUTCString()}; path=/${identifier}`;
            styling.setMapStyle(style);
        }
  
        state.mapConfig.skipCameraPositioning = true; 

        this.views.forEach((view, index) => {
            if (view.time === undefined)
                view.time = defaultDurationSeconds;

            let { options } = view;
            options.id = `${identifier}-${index}`;
            options.identifier = identifier
            const engine = view.engine = new view.engine(options);
            this.engines.push(engine);
        });

        if (displayLogo) {
            const { customerLogo } = this.controlPanel;
            this.controlPanel.setCustomerLogo(displayLogo);
            const imgLoaded = new Promise(res => {
                if (customerLogo.complete) {
                    return res();
                }
                customerLogo.onload = res;
            });

            imgLoaded.then(_ => styling.show(customerLogo));
        }
    }

    haltMap() {
        let owner = this.placeholder || document.getElementById(mapContainerId);
        styling.hide(owner);
        const { titleBar } = this.controlPanel;
        titleBar.setSubTitle('Data loading failed, please try again later or reach out to support.');
    }

    removeFailedInit(failedEngine, failureDetails) {
        const { engines, views } = this;
        const index = engines.indexOf(failedEngine);
        if (index !== -1) {
            engines.splice(index, 1);
            const failingView = views[index];
            const name = failingView?.options?.mapTitle ?? index;
            console.error(`{Failed to initialize '${name}' view, skipping it. Details: ${failureDetails}`);
            views.splice(index, 1);
        }
    }

    /**
     *  The index of the currently played view in the playlist.
     */
    get currentViewIndex() {
        return this.getViewIndex(this.currentView);
    }

    get currentViewSecondsRemain() {
        const currentViewTiming = this.currentView?.time ?? 0;
        return Math.floor(currentViewTiming - this.secondsSinceSwap);
    }

    get secondsSinceSwap() {
        const now = new Date();
        return (now - this.swapTime) / 1000;
    }

    show() {
        this.trigger(this.startFromIndex); 
    }

    hide() { this.currentView?.pause(); }

    swap(nextView) {
        if (this.currentView != nextView) {
            const nextEngine = nextView.engine;
            this.currentView?.engine.stage.hide();

            nextEngine.setActive();
            
            this.currentView = nextView;
            this.swapTime = new Date();
        }
    };
};

export default PlaylistEngine;